/**
 * A utility function to normalize the beneficiary data
 * to the model that was firstly created for the application.
 *
 * It is being used at the beneficiaries step from both the nad feature and the checkout.
 * */

const formattedCpf = (value) => {
    if (!value) return '';

    return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
}

const BeneficiaryNormalizer = rawBeneficiary => {
    let item = {...rawBeneficiary};

    const DATA = {
        isBrazilian: !!item.nationality,
        id: item.customerId,
        entityId: item.entityId,
        name: item.nome || item.name,
        email: item.email,
        birthdate: item.dob,
        cpf: formattedCpf(item.taxVat),
        country: item.country || undefined,
        gender: item.gender.toString(),
        phone: item.telephone,
        passport: item.passport,
        postalCode: item.cep,
        address: item.address,
        number: item.number,
        city: item.city,
        complement: item.complement,
        neighborhood: item.neighborhood,
        state: item.uf,
        sponsor: item.sponsor,
        isCustomer: item.isCustomer,
        affiliation: item?.affiliation,
        // Parental fields
        responsibleName: item?.responsibleName || "",
        responsibleEmail: item?.responsibleEmail || "",
        responsibleTaxVat: item?.responsibleTaxVat || "",
        responsiblePassport: item?.responsiblePassport || "",
        // Social name feature
        includeSocialName: item?.includeSocialName || false,
        socialName: item?.socialName || ""
    };

    let extraOpts = [
        'nationality',
        'customerId',
        'entityId',
        'nome',
        'name',
        'email',
        'dob',
        'taxVat',
        'country',
        'gender',
        'telephone',
        'passport',
        'cep',
        'address',
        'number',
        'city',
        'complement',
        'neighborhood',
        'uf',
        'sponsor',
        'isCustomer',
        'affiliation',
        'responsibleName',
        'responsibleEmail',
        'responsibleTaxVat',
        'responsiblePassport',
        'includeSocialName',
        'socialName',
    ];

    for (let index in extraOpts) {
        delete item[extraOpts[index]];
    }

    return {
        ...DATA,
        ...(Object.keys(item).length > 0 && {
            rest: {
                ...item
            }
        })
    };
}

export default BeneficiaryNormalizer;
